import { render } from "./product-usps.vue?vue&type=template&id=39e40e60"
import script from "./product-usps.vue?vue&type=script&lang=js"
export * from "./product-usps.vue?vue&type=script&lang=js"

import "./product-usps.vue?vue&type=style&index=0&id=39e40e60&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__